import { Skeleton, Stack } from "@mui/material";
import { isEmpty } from "lodash";

import { useCase } from "../ExperimentalHomeHealth/Cases/api/useCase";
import { useVisit } from "../ExperimentalHomeHealth/Cases/api/useVisit";
import { ChatWidgetCard } from "./ChatWidgetCard";

interface VisitInviteRequestMessageProps {
  visitId: string | undefined;
}

export function VisitInviteRequestMessage(props: VisitInviteRequestMessageProps) {
  const { visitId } = props;

  const { data: visit, isLoading: isVisitLoading, isError: isVisitError } = useVisit(visitId);
  const { caseId, type: visitType, workerReq } = visit?.attributes ?? {};

  const {
    data: caseRecord,
    isLoading: isCaseLoading,
    isError: isCaseError,
  } = useCase(caseId ?? undefined);

  const patient = caseRecord?.attributes.patient;
  const patientName = patient?.attributes.externalPatientIdentifier;

  if (isVisitError || isCaseError || isEmpty(visitId) || isEmpty(caseId)) {
    return <span />;
  }

  if (isVisitLoading || isCaseLoading) {
    return (
      <Stack alignItems="flex-end" className="sendbird-admin-message">
        <Skeleton variant="text" width="50%" height="1.5rem" />
      </Stack>
    );
  }

  return (
    <Stack alignItems="flex-end" className="sendbird-admin-message">
      <ChatWidgetCard
        statusChip={null}
        title={`${visitType} ${workerReq} visit invite sent for ${patientName}`}
        subtitle=""
        actions={null}
      />
    </Stack>
  );
}
